import { getHomeDataJSON } from '../../api/answer'

export default {
  namespaced: true,
  state: {
    homeData: []
  },
  // mutations 修改器，用于修改state中的定义的状态变量,同步
  mutations: {
    setHomeData: (state, payload) => {
      const { grade, volume, data } = payload
      state.home.homeData[grade + '/' + volume] = data
    },
    setHomeAllData: (state, payload) => {
      const { grade, volume, data } = payload
      state.homeData = [
        ...state.homeData,
        {
          key: grade + '/' + volume,
          list: data
        }
      ]
    }
  },
  // 存放异步操作，由 action 去触发 mutation
  actions: {
    async getHomeData({ state, commit, dispatch, rootGetters }, { grade, volume }) {
      const gradeTermkey = rootGetters.userGrade + '/' + rootGetters.userTerm
      const found = state.homeData.find(({ key }) => key === gradeTermkey)
      if (found) {
        return found.list
      } else {
        const res = await getHomeDataJSON({ grade, volume })
        let courses = await dispatch('dictionary/getCouresVersionListFromJSON', grade, {
          root: true
        })
        const versionData = await dispatch('dictionary/getAnswerVersion', null, { root: true })
        courses.unshift({
          course: 0,
          name: '课本',
          versions: versionData.map(({ id, wbVersion }) => ({ version: id, name: wbVersion }))
        })
        courses = courses.map((c) => ({ ...c, books: [] }))
        // console.log('courses', courses)
        const versionArr = versionData.reduce((arr, item) => {
          arr[item.id] = item
          return arr
        }, [])
        res.forEach((item) => {
          const courseId =
            item.book.category === 'keben' || item.book.category === 'keben_answer'
              ? 0
              : item.book.course
          const course = courses.find(({ course }) => course === courseId)
          if (course) {
            course.books = [
              ...course.books,
              {
                ...item,
                ...item.book,
                versionName: versionArr[item.book.version]
                  ? versionArr[item.book.version].wbVersion
                  : ''
              }
            ]
          }
        })
        // 保存所有的数据
        commit('setHomeAllData', {
          grade,
          volume,
          data: courses
        })
        return courses
      }
    }
  },
  getters: {
    homeData(state) {
      return state.homeData
    },
    curHomeData(state, getters, rootState, rootGetters) {
      const gradeTermkey = rootGetters.userGrade + '/' + rootGetters.userTerm
      const found = state.homeData.find(({ key }) => key === gradeTermkey)
      return found ? found.list : []
    }
  }
}
